import { Container } from '@/components/layout';
import { AboutContent } from '@/components/composed';

export function AboutPage() {
  return (
    <Container maxWidth="xl">
      <AboutContent />
    </Container>
  );
}
